import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { GigyaAPI } from '@ciam/gigya-api';
import { useValidatorStore } from '@features/proxy';
import { clearLoginInfo, useLoginInfoStore } from '@features/shared';

export const RecordLastLogin = () => {
  const [searchParams] = useSearchParams();
  const { userInfo } = useLoginInfoStore();
  const { setValidateStep } = useValidatorStore();
  const channel = searchParams.get('channel') ?? '';

  const recordLastLogin = useCallback(async () => {
    clearLoginInfo();

    if (searchParams.get('channel') === 'btp') return setValidateStep('validate-all-done');

    const channelData = {} as Record<string, { lastLogin: Date }>;
    channelData[channel] = {
      lastLogin: new Date(),
    };

    await GigyaAPI.accounts.setAccountInfo({
      UID: userInfo.UID,
      data: {
        channels: channelData,
      },
    });

    return setValidateStep('validate-all-done');
  }, [searchParams, setValidateStep, channel, userInfo.UID]);

  useEffect(() => {
    console.log('record last login');
    recordLastLogin();
  }, [recordLastLogin]);

  return null;
};
